export function getImageUrl(image, entityType, entityId, subfolder = '') {
  if (image?.url) return image.url;

  const bucket = process.env.REACT_APP_AWS_BUCKET_NAME;
  const region = process.env.REACT_APP_AWS_REGION || 'us-east-1';
  const client = process.env.REACT_APP_CLIENT;

  // Función para armar path local o S3
  const buildPath = basePath => {
    let filename = '';
    filename = typeof image === 'string' ? image : image?.filename;
    if (
      image?.provider === 's3' ||
      entityType == 'realestate' ||
      entityType == 'users'
    ) {
      return `https://${bucket}.s3.${region}.amazonaws.com/${basePath}/${filename}`;
    }
    return `${client}/${basePath}/${filename}`;
  };

  // Casos según entityType
  switch (entityType) {
    case 'realestate':
      return buildPath(`uploads/${entityType}/logo`);
    case 'users':
      // no llevan entityId en la ruta
      return buildPath(`uploads/${entityType}/profile-pictures`);
    default:
      if (subfolder) {
        return image?.filename?.includes(entityId)
          ? buildPath(`uploads/${entityType}`)
          : buildPath(`uploads/${entityType}/${entityId}/${subfolder}`);
      } else {
        return image?.filename?.includes(entityId)
          ? buildPath(`uploads/${entityType}`)
          : buildPath(`uploads/${entityType}/${entityId}`);
      }
  }
}
